import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import Translations from "./Translations";

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en-US",
    resources: { ...Translations },
    debug: process.env.REACT_APP_ENV !== "production",
    react: {
      useSuspense: true,
    },
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
